import _ from "underscore";
import QuickCreateMenu from "../../Menus/QuickCreateMenu";
import useUpdateSubitemField from "../../../api/api-hooks/subitems/useUpdateSubitemField";
import StrUtils from "../../../utils/StrUtils";

const quickCreateVariableIdentifiers = ["record", "user"];

const SubitemQuickCreateMenu = ({
  fieldSchema,
  toggleAddSubitem,
  toggleImportCSVDrawer,
  moduleAPIName,
  setSelectedPrefill,
  parentRecord,
  selectedPrefill,
  publicForm = false,
}) => {
  const { updateSubitemField, updatingSubitem } = useUpdateSubitemField();
  let currentPrefills =
    fieldSchema?.Prefills?.length > 0 ? fieldSchema?.Prefills : [];
  const defaultPrefill = _.findWhere(fieldSchema?.Prefills, {
    id: selectedPrefill ?? fieldSchema?._SelectedPrefill,
  });

  return (
    <QuickCreateMenu
      variableIdentifiers={quickCreateVariableIdentifiers}
      setSelectedPrefill={setSelectedPrefill}
      moduleAPIName={moduleAPIName}
      prefills={fieldSchema?.Prefills}
      handleCreate={createItem}
      handleUpdate={updateItem}
      handleDelete={deleteItem}
      handleReorder={reorderItems}
      updating={updatingSubitem}
      toggleCreateRecords={toggleAddSubitem}
      toggleImportCSV={toggleImportCSVDrawer}
      fieldSchema={fieldSchema}
      defaultPrefill={defaultPrefill}
      record={parentRecord}
      savedPrefillID={fieldSchema?._SelectedPrefill}
      onSaveAsDefault={(id) => {
        const foundPrefill = _.findWhere(fieldSchema?.Prefills, {
          id,
        });

        if (!foundPrefill) return;

        if (defaultPrefill && id === defaultPrefill) {
          return updateSubitemField({
            moduleAPIName: parentRecord._ModuleAPIName,
            fieldAPIName: fieldSchema.APIName,
            payload: {
              _SelectedPrefill: "",
            },
          });
        }

        updateSubitemField({
          moduleAPIName: parentRecord._ModuleAPIName,
          fieldAPIName: fieldSchema.APIName,
          payload: {
            _SelectedPrefill: id,
          },
        });
      }}
      usePageSelection={false}
      disableLayouts={true}
      publicForm={publicForm}
    />
  );

  function createItem(prefill) {
    let newPrefill = prefill.payload;
    newPrefill.id = StrUtils.uuidv4();
    currentPrefills.push(newPrefill);

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        Prefills: currentPrefills,
      },
    });

    prefill.onSuccess();
  }

  function updateItem(prefill) {
    let updatedPrefill = prefill.payload;
    updatedPrefill.id = prefill.id;

    const updatedPrefills = currentPrefills.map((item) =>
      item.id === updatedPrefill.id ? updatedPrefill : item
    );

    updateSubitemField({
      moduleAPIName: parentRecord._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        Prefills: updatedPrefills,
      },
    });

    prefill.onSuccess();
  }

  function deleteItem(prefill) {
    const updatedPrefills = currentPrefills.filter(
      (item) => item.id !== prefill.id
    );

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        Prefills: updatedPrefills,
      },
    });
  }

  function reorderItems(result) {
    let newOrderedIds = result.newOrder;

    currentPrefills.sort((a, b) => {
      const aIndex = newOrderedIds.indexOf(a.id);
      const bIndex = newOrderedIds.indexOf(b.id);
      return aIndex - bIndex;
    });

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        Prefills: currentPrefills,
      },
    });
  }
};

export default SubitemQuickCreateMenu;
